import { render } from "./Bitacora.vue?vue&type=template&id=8d0a69f4&scoped=true"
import script from "./Bitacora.vue?vue&type=script&lang=js"
export * from "./Bitacora.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=8d0a69f4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0a69f4"]])

export default __exports__